<ng-container *ngIf="!(isAuthLoading$ | async); else loading">
    <router-outlet></router-outlet>
</ng-container>

<ng-template #loading>
    <app-root-loader></app-root-loader>
</ng-template>
